module.exports = "/_next/static/images/new-8e1e8c461d611523ec504b2e2b1ee6cf.svg";